export const sportsOptions = [
  { value: "baseball", label: "Baseball" },
  { value: "softball", label: "Softball" },
] as const;
